'use client'

import { LoadingLink } from "../feedback";
import { Button } from "../buttons";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "../overlay";
import { Avatar, AvatarFallback } from "../data-display";
import { LoadingSpinner } from "../feedback";
import { LogOut } from 'lucide-react';
import Link from "next/link";
import { signOut } from "next-auth/react";
import { useClientSession } from "../../hooks";

export function SessionArea() {
  const { session, status } = useClientSession();
  const isSignedIn = !!session?.user;

  const handleSignOut = () => {
    signOut();
  };

  // Show loading spinner when authentication state is loading
  if (status === 'loading') {
    return (
      <Button size="sm" variant="ghost" className="h-8 w-8 p-0">
        <LoadingSpinner size="small" />
      </Button>
    )
  }

  if (!isSignedIn) {
    return (
      <Button size="sm" variant="outline" asChild className="bg-transparent text-hero-text hover:bg-hero-text hover:text-white border-hero-text">
        <Link href="/users/signin">
          Sign In
        </Link>
      </Button>
    );
  }

  const userInitial = session?.user?.name?.[0] ?? session?.user?.email?.[0] ?? 'U'

  return (
    <>
      <LoadingLink href="/dashboard" loadingClassName="opacity-70 cursor-wait">
        <Button variant="outline" asChild>
          Dashboard
        </Button>
      </LoadingLink>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button size="sm" variant="ghost" className="h-8 w-8 p-0 cursor-pointer">
            <Avatar className="h-8 w-8">
              <AvatarFallback>
                {userInitial}
              </AvatarFallback>
            </Avatar>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-56">
          <DropdownMenuItem onClick={handleSignOut} className="cursor-pointer">
            <LogOut className="mr-2 h-4 w-4" />
            Sign Out
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  )
}
